import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4825fc46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main__memberBox" }
const _hoisted_2 = { class: "main__memberBox__topic" }
const _hoisted_3 = { class: "main__memberBox__topic__tooltip" }
const _hoisted_4 = { class: "main__memberBox__topic__tooltipText" }
const _hoisted_5 = { class: "main__memberBox__addMember" }
const _hoisted_6 = {
  key: 0,
  class: "main__memberBox__addMember__memberList"
}
const _hoisted_7 = { class: "main__memberBox__addMember__addButton__text" }


const __default__ = {
  name: 'AddMember'
}

import { ref, toRefs, computed } from 'vue'
import { NTooltip, NDivider } from 'naive-ui'
import { useAppDialog } from '@/components/appDialog'
import AddMemberItem from './addMemberItem.vue'
import { useUserStore } from '@/store/user'
import { storeToRefs } from 'pinia'
import Icon from '@teams/common/components/icon'

export interface RoleType {
  roleId: number
  roleName: string
  roleDesc: string
}
export interface Member {
  avatar: string
  name: string
  userId: number
  roleId: number
}
export interface UserRoleIdsType {
  role_id: number
  userids: number[]
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    roleInfo: null,
    allUserIds: null
  },
  emits: ['selectedMember', 'cancelOneUser'],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as {
  roleInfo: RoleType
  allUserIds: number[]
}



const userStore = useUserStore()
const { userId } = storeToRefs(userStore)
const { roleInfo, allUserIds } = toRefs(props)
const memberList = ref<Member[]>([])
const userRoleIds = computed<UserRoleIdsType>(() => {
  return {
    role_id: roleInfo.value.roleId,
    userids: memberList.value.map(item => item.userId)
  }
})
const appDialog = useAppDialog()
// 打开联系人选择器
const onAddMember = () => {
  appDialog.show({
    name: 'MemberSelector',
    componentEvents: {
      selected: onSelected
    },
    componentProps: {
      disableUserList: [
        { userid: userId.value },
        ...allUserIds.value.map(item => {
          return { userid: item }
        })
      ]
    }
  })
}
// 保存联系人选择器中选定的人员信息
const onSelected = items => {
  const arr = items.map(item => {
    return {
      avatar: item.avatar,
      name: item.name,
      userId: item.userid,
      roleInfo: props.roleInfo.roleId
    }
  })
  memberList.value = [...memberList.value, ...arr]
  emits('selectedMember', memberList.value)
}
// 删除单个成员
const deleteOnce = (userId: number) => {
  const index = memberList.value.findIndex(item => item.userId === userId)
  if (index >= 0) {
    memberList.value = [
      ...memberList.value.slice(0, index),
      ...memberList.value.slice(index + 1)
    ]
    emits('cancelOneUser', userId)
  }
}
expose({
  userRoleIds
})

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_scrollbar = _resolveComponent("n-scrollbar")!
  const _component_n_space = _resolveComponent("n-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(NTooltip), {
        trigger: "hover",
        placement: "bottom-start",
        style: {"max-width":"220px"},
        "show-arrow": false
      }, {
        trigger: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(_unref(roleInfo).roleName), 1),
            _createVNode(_unref(Icon), {
              name: "tips",
              size: 16,
              fill: "transparent",
              class: "main__memberBox__topic__tooltip__icon"
            })
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(roleInfo).roleDesc), 1)
        ]),
        _: 1
      }),
      (memberList.value.length > 0)
        ? (_openBlock(), _createBlock(_component_n_button, {
            key: 0,
            text: "",
            class: "main__memberBox__topic__addButton",
            onClick: onAddMember
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Icon), {
                name: "add",
                size: 16
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(NDivider), { class: "main__memberBox__divider" }),
    _createElementVNode("div", _hoisted_5, [
      (memberList.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_n_scrollbar, { style: {"max-height":"270px"} }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(memberList.value, (item) => {
                  return (_openBlock(), _createBlock(AddMemberItem, {
                    key: item.userId,
                    avatar: item.avatar,
                    name: item.name,
                    onDeleteOnce: ($event: any) => (deleteOnce(item.userId))
                  }, null, 8, ["avatar", "name", "onDeleteOnce"]))
                }), 128))
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            text: "",
            class: "main__memberBox__addMember__addButton",
            onClick: onAddMember
          }, [
            _createVNode(_component_n_space, { justify: "center" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Icon), {
                  name: "add",
                  size: 16
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_7, _toDisplayString(`添加${_unref(roleInfo).roleName}`), 1)
          ]))
    ])
  ]))
}
}

})